/* eslint-disable no-unused-vars */
import { Suspense } from 'react';
import { QueryClientProvider } from 'react-query';
import { HotsauceProvider } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { onNavigate } from '@hotjar/webapp/utils/routing/on-navigate';
import { BrowserRouter } from '@hotjar/webapp-routing';

import { queryClient } from '@hotjar/webapp/utils/react-query';

const react2angular = require('react2angular').react2angular;

function Providers({ children }) {
    const { i18n, ready } = useTranslation();

    let i18nConfig;

    // We use this function in the data-request page, but we don't currently use the same translation implementation
    // there so we don't attempt to configure it if i18n isn't set up in the same way.
    if (i18n.getResourceBundle) {
        i18nConfig = {
            strings: ready ? i18n.getResourceBundle(i18n.language, 'hotsauce') : {}
        };
    }
    return (
        <HotsauceProvider i18n={i18nConfig} onNavigate={onNavigate}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <Suspense fallback={<></>}>{children}</Suspense>
                </BrowserRouter>
            </QueryClientProvider>
        </HotsauceProvider>
    );
}

export const wrappedR2A = (Component, ...args) => {
    return react2angular(
        (props) => (
            <Suspense fallback={<></>}>
                <Providers>
                    <Component {...props} />
                </Providers>
            </Suspense>
        ),
        ...args
    );
};
